import { useState, useEffect, useRef, useReducer, Reducer, useCallback } from 'react'
import axios, { Canceler } from 'axios'

import { useAPI } from '../api'

export type AdminResponse = {
  id: number
  name: string
  role: string
}

const useAdmins = (onForbidden?: Function, onError?: Function) => {
  const [admins, setAdmins] = useState<AdminResponse[]>([])
  const cancelRef = useRef<Canceler>()
  const { fetchData } = useAPI({ cancelRef, onError, onForbidden })

  const fetchAdmins = () => {
    return fetchData(`/admins`)
      .then((resp) => {
        setAdmins(resp.data)
        return resp.data
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
  }

  useEffect(() => {
    fetchAdmins()
  }, [])

  return {
    admins,
    fetchAdmins,
  }
}

export { useAdmins }
